// generate=ts:EventsIndex
import { AgentEventType } from './agent-events';
import { QueueEventType } from './queue-events';
import { SessionEventType } from './session-events';
export const EventTypes = {
    agent: AgentEventType,
    queue: QueueEventType,
    session: SessionEventType,
};
/** Map of `<type>.*` patterns to individual event types */
export const EventGroups = {
    [EventTypes.agent.all]: [
        EventTypes.agent.away,
        EventTypes.agent.ready,
        EventTypes.agent.sessionDelivered,
        EventTypes.agent.sessionOffered,
        EventTypes.agent.sessionRejected,
        EventTypes.agent.sessionRescinded,
        EventTypes.agent.sessionTerminated,
        EventTypes.agent.status,
        EventTypes.agent.wrapupCompleted,
        EventTypes.agent.wrapupStarted,
    ],
    [EventTypes.queue.all]: [
        EventTypes.queue.agentAdded,
        EventTypes.queue.agentRemoved,
        EventTypes.queue.created,
        EventTypes.queue.deleted,
        EventTypes.queue.sessionDelivered,
        EventTypes.queue.sessionJoined,
        EventTypes.queue.sessionLeft,
        EventTypes.queue.status,
    ],
    [EventTypes.session.all]: [
        EventTypes.session.created,
        EventTypes.session.deleted,
    ],
};
// end-generate'
//# sourceMappingURL=index.js.map